import { render, staticRenderFns } from "./webHooks.vue?vue&type=template&id=a5d819ac&scoped=true"
import script from "./webHooks.vue?vue&type=script&lang=js"
export * from "./webHooks.vue?vue&type=script&lang=js"
import style0 from "./webHooks.vue?vue&type=style&index=0&id=a5d819ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5d819ac",
  null
  
)

export default component.exports